import axios from "axios";
import { useState, useEffect, useRef } from "react";
import { useNavigate, Navigate, Outlet, useLocation } from "react-router-dom";
import { useContextTranslate } from "../../components/Translate/ContextProvider";

export const baseUrl = "https://aqar-plus.icrcompany.net/api/";
export const fileUrl = "https://aqar-plus.icrcompany.net/storage/";

//!=============================================================> post data login
export const useLOGIN = (initialState) => {
  const [formData, setFormData] = useState(initialState); // data
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };
  const handleSubmit = async (url) => {
    setLoading(true);
    setError("");
    const formDataToSend = new FormData();
    for (const [key, value] of Object.entries(formData)) {
      formDataToSend.append(key, value);
    }
    axios
      .post(`${baseUrl}${url}`, formDataToSend)
      .then((req) => {
        setLoading(false);
        setError("");
        localStorage.setItem("token", req.data.data.token);
        navigate("/");
      })
      .catch((e) => {
        setError(e.response.data.message);
        setLoading(false);
      });
  };
  //
  return {
    formData,
    handleChange,
    loading,
    error,
    handleSubmit,
    setFormData,
    setError,
  };
};
// !======================================================================================
export const usePOST = (initialState) => {
  const [formData, setFormData] = useState(initialState);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [viewFile, setViewFile] = useState("");
  const [viewImages, setViewImages] = useState({});
  const [images, setImages] = useState({});
  const [checkArray, setCheckArray] = useState({});
  const navigate = useNavigate();
  const { setMessage } = useContextTranslate();
  //=====================================================> function change   data all
  const handleChangeInput = (event) => {
    const { name, value, type, files, checked } = event.target;
    const newValue =
      type === "file" ? files[0] : type === "checkbox" ? checked : value;
    type === "file" && setViewFile(URL.createObjectURL(newValue));
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: newValue === true ? 1 : newValue === false ? 0 : newValue,
    }));
  };
  //=====================================================>  function change  array images
  const handleChangeArrayImages = (event) => {
    const { files, name } = event.target;
    setImages({ ...images, [name]: [files[0]] });
    if (images[name]) {
      setImages({
        ...images,
        [name]: [...images[name], files[0]],
      });
    }
    setViewImages({ ...viewImages, [name]: [URL.createObjectURL(files[0])] });
    if (images[name]) {
      setViewImages({
        ...viewImages,
        [name]: [...viewImages[name], URL.createObjectURL(files[0])],
      });
    }
  };
  //=====================================================> function change array checkbox
  const handleCheckedArray = (e) => {
    const { value, checked, name } = e.target;
    if (checked) {
      setCheckArray({ ...checkArray, [name]: [value] });
      if (checkArray[name]) {
        setCheckArray({
          ...checkArray,
          [name]: [...checkArray[name], value],
        });
      }
    } else {
      if (checkArray[name]) {
        setCheckArray({
          ...checkArray,
          [name]: checkArray[name].filter((p) => p !== value),
        });
      }
    }
  };

  //=====================================================> post data
  const handleSubmit = async (url, route, noRoute) => {
    setLoading(true);
    setError("");

    const formDataToSend = new FormData();
    for (const [key, value] of Object.entries(formData)) {
      formDataToSend.append(key, value);
    }
    for (const [key, value] of Object.entries(checkArray)) {
      for (let i = 0; i < value.length; i++) {
        formDataToSend.append(key, value[i]);
      }
    }
    for (const [key, value] of Object.entries(images)) {
      for (let i = 0; i < value.length; i++) {
        formDataToSend.append(key, value[i]);
      }
    }

    axios
      .post(`${baseUrl}${url}`, formDataToSend, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
      .then((req) => {
        setLoading(false);
        setError("");
        setFormData({
          content: "",
        });
        route
          ? navigate(route)
          : noRoute
          ? console.log("D")
          : window.history.go(-1);
      })
      .catch((e) => {
        setError(e?.response?.data?.message);
        setMessage(e?.response?.data?.message);
        setLoading(false);
      });
  };

  return {
    formData,
    setFormData,
    viewFile, //  لعرض الصورة او فيديو .....
    setViewFile, // ((local)) لحذف الصورة
    viewImages, // لعرض الصور
    setViewImages, // ((local)) لحذف الصور
    images, //api  لأرسال الصور الى
    setImages, //api  لحذف الصور الى
    error,
    setError,
    loading,
    setLoading,
    handleChangeInput,
    handleCheckedArray,
    handleChangeArrayImages,
    handleSubmit,
  };
};
//!=============================================================>start fetch data
export const useFETCH = (url, urlDelete) => {
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isErroe, setIsError] = useState("");
  const { setMessage } = useContextTranslate();
  // const navigate = useNavigate();

  useEffect(() => {
    setIsLoading(true);
    if (url) {
      axios
        .get(`${baseUrl}${url}`, {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        })
        .then((req) => {
          if (req) {
            setData(req);
            setIsLoading(false);
            setIsError("");
          }
        })
        .catch((e) => {
          setIsLoading(false);
          setIsError("خطأ في جلب البيانات");
          setMessage(e.response.data.message);
          if (e?.request?.status === 401) {
            localStorage.removeItem("token");
          }
          // if (e.request.status === 403) {
          //   navigate("/403");
          // }
          // if (e.request.status === 500) {
          //   navigate("/500");
          // }
        });
    }
  }, [url]);

  //?=============================================================> deleteItem
  const deleteItem = async (e) => {
    setIsLoading(true);
    axios
      .delete(`${baseUrl}${urlDelete || url}${e ? `/${e.id}` : ""}`, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
      .then((req) => {
        setIsLoading(false);
        setMessage(req?.data.data);
        setIsError("تم الحذف  بنجاح");
        // window.location.reload();
      })
      .catch((e) => {
        setMessage(e?.response?.data?.message);
        setIsLoading(false);
        setIsError(" خطأ في الحذف  حاول مرة آخرى");
      });
  };
  return { data, isLoading, isErroe, deleteItem };
};
//=============================================================> end fetch data

//!=============================================================> pagination or filter or search

export const useFilter = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const handleParamsClick = (name, value) => {
    searchParams.set(name, value);
    const newUrl = `${location.pathname}?${searchParams.toString()}`;
    navigate(newUrl);
  };
  const handleParamsDelete = (name) => {
    searchParams.delete(name);
    const newUrl = `${location.pathname}?${searchParams.toString()}`;
    navigate(newUrl);
  };
  const handlePageClick = (event) => {
    handleParamsClick("page", event?.selected + 1);
  };
  return {
    searchParams,
    handlePageClick,
    handleParamsClick,
    handleParamsDelete,
  };
};

export default useFilter;
//!=============================================================> عدم دخول من غير تسجيل دخول
export const RequireAuth = () => {
  if (!window.localStorage.getItem("token")) {
    return <Navigate to="/login" />;
  }

  return <Outlet />;
};
export const RequireRoute = ({ condition, route }) => {
  if (condition) {
    return <Navigate to={route} />;
  }

  return <Outlet />;
};
//! =============================================================>عدم فتح صفحة تسجيل دخول اذا مسجل مسيقا
export const RequireLogin = () => {
  if (window.localStorage.getItem("token")) {
    return <Navigate to="/" />;
  }
  return <Outlet />;
};
//!=============================================================> تكبير الصورة
export const useClose = () => {
  const [open, setOpen] = useState(false);
  const mouse = useRef();
  useEffect(() => {
    const handler = (e) => {
      if (mouse.current) {
        if (!mouse.current.contains(e.target)) {
          setOpen(false);
        }
      }
    };
    document.addEventListener("mousedown", handler);
    return () => {
      document.addEventListener("mousedown", handler);
    };
  }, []);

  return { open, setOpen, mouse };
};
//!=============================================================>
export const clickZoomInImage = (event) => {
  event.target.requestFullscreen();
};

export const useContactUs = (url) => {
  const [loading, setLoading] = useState(false);
  const { setMessage } = useContextTranslate();
  const updateContactUs = (info, info_value) => {
    setLoading(true);
    axios
      .post(
        `${baseUrl}${url}`,
        {
          info: info,
          // [en_info_value ? "en_info_value" : "info_value"]: info_value,
          info_value: info_value,
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      )
      .then((req) => {
        setLoading(false);
      })
      .catch((e) => {
        setMessage(e?.response?.data?.message);
        setLoading(false);
      });
  };
  return { updateContactUs, loading };
};
